module.exports = require('lodash').set